import { useEffect, useState } from "react";
import { partnersAPI } from "../api";

const PartnersSection = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    partnersAPI.getAll()
      .then((data) => setPartners(data || []))
      .catch(() => setPartners([]));
  }, []);

  if (!partners.length) return null;

  // Duplicate for seamless infinite scroll
  const loop = [...partners, ...partners, ...partners];

  return (
    <section className="py-16 bg-black border-y border-yellow-500/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 space-y-3">
          <span className="text-yellow-400 font-semibold text-sm uppercase tracking-wider">
            Learning Partners
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Continuous <span className="gradient-text">Learning Journey</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Expanding my skills through trusted educational platforms
          </p>
        </div>

        <div className="relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none"></div>

          <div
            className="flex items-center gap-12 md:gap-16 partners-marquee"
            data-testid="partners-marquee"
            style={{ width: "fit-content" }}
          >
            {loop.map((partner, index) => (
              <a
                key={`${partner.id || partner.name}-${index}`}
                href={partner.website || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 group relative"
                data-testid="partner-logo"
              >
                <div className="w-40 h-20 md:w-48 md:h-24 flex items-center justify-center p-4 rounded-xl bg-[#0d0d0d] border border-yellow-500/30 hover:border-yellow-400 transition-all duration-300 hover:shadow-[0_0_24px_rgba(230,194,0,0.45)]">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-w-full max-h-full object-contain transition-all duration-300 group-hover:scale-110"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/200x80?text=" + partner.name.replace(/\s/g, "+");
                    }}
                  />
                </div>
                {partner.courses && (
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-4 py-3 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none max-w-xs shadow-xl z-20">
                    <div className="font-semibold mb-1 text-yellow-400">{partner.name}</div>
                    <div className="text-gray-300 whitespace-normal">{partner.courses}</div>
                  </div>
                )}
              </a>
            ))}
          </div>
        </div>

        <style jsx>{`
          .partners-marquee {
            animation: scroll-partners 30s linear infinite;
          }
          .partners-marquee:hover {
            animation-play-state: paused;
          }
          @keyframes scroll-partners {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-33.333%); }
          }
        `}</style>
      </div>
    </section>
  );
};

export default PartnersSection;
